import { render, staticRenderFns } from "./MtipotransporteGrid.vue?vue&type=template&id=76bc5706"
import script from "./MtipotransporteGrid.vue?vue&type=script&lang=js"
export * from "./MtipotransporteGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports